import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {SharedComponent} from './shared.component';

import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from '@angular/material/dialog';
import {MatPaginatorModule} from '@angular/material/paginator';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatRadioModule} from '@angular/material/radio';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastrModule} from 'ngx-toastr';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {CookieService} from 'ngx-cookie-service';
import {InfoDialogComponent} from './dialogs/info-dialog/info-dialog.component';
import {ConfirmationDialogComponent} from './dialogs/confirmation-dialog/confirmation-dialog.component';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {MatExpansionModule} from '@angular/material/expansion';
import {ExternalContentViewerComponent} from './external-content-viewer/external-content-viewer.component';
import {AgmCoreModule} from '@agm/core';
import {environment} from '../../environments/environment';
import {AgmSnazzyInfoWindowModule} from '@agm/snazzy-info-window';
import {OrganisationSelectorComponent} from './header/organisation-selector/organisation-selector.component';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {PopoverModule} from 'ngx-smart-popover';
import {UserApprovalStatusComponent} from './information-displayers/user-approval-status/user-approval-status.component';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {ColorPickerModule} from 'ngx-color-picker';
import {NgxSpinnerModule} from 'ngx-spinner';
import {MatDividerModule} from '@angular/material/divider';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSortModule} from '@angular/material/sort';
import {NgxTippyModule} from 'ngx-tippy-wrapper';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [SharedComponent, FooterComponent, HeaderComponent, InfoDialogComponent, ConfirmationDialogComponent, ConfirmationDialogComponent, ExternalContentViewerComponent, OrganisationSelectorComponent, UserApprovalStatusComponent],
  exports: [
    RouterModule, NgxDropzoneModule, FooterComponent, NgxSpinnerModule, MatDividerModule, MatDialogModule, MatSortModule,
    HeaderComponent, MatButtonModule, MatCheckboxModule, MatInputModule, MatFormFieldModule, FlexLayoutModule, MatButtonToggleModule, NgxTippyModule,
    MatMenuModule, MatIconModule, MatGridListModule, MatCardModule, MatSelectModule, MatDatepickerModule, PopoverModule, ColorPickerModule,
    MatNativeDateModule, MatRadioModule, FormsModule, ReactiveFormsModule, MatTabsModule, MatTableModule, MatTooltipModule, MatSlideToggleModule, ToastrModule,
    MatAutocompleteModule, NgxDaterangepickerMd, MatPaginatorModule, MatExpansionModule, AgmCoreModule, AgmSnazzyInfoWindowModule, PerfectScrollbarModule, MatToolbarModule,
  ],
  imports: [
    RouterModule, NgxDropzoneModule, ReactiveFormsModule, NgxSpinnerModule,
    MatDividerModule, MatSortModule, FlexLayoutModule,
    MatButtonModule, MatCheckboxModule, MatInputModule, MatFormFieldModule, MatMenuModule, MatIconModule, PopoverModule,
    MatGridListModule, MatCardModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, ColorPickerModule, MatButtonToggleModule, NgxTippyModule,
    MatRadioModule, FormsModule, MatTabsModule, MatTableModule, MatTooltipModule, MatSlideToggleModule, ToastrModule.forRoot(
      {
        timeOut: 15000,
        positionClass: 'toast-top-right',
        progressBar: true,
        preventDuplicates: true,
      }
    ),
    MatAutocompleteModule, MatDialogModule, NgxDaterangepickerMd.forRoot(), MatPaginatorModule, MatExpansionModule, AgmCoreModule.forRoot({
      apiKey: environment.googleMapAPIKey,
      libraries: ['places', 'drawing', 'geometry']
    }), AgmSnazzyInfoWindowModule, PerfectScrollbarModule, MatToolbarModule
  ],
  entryComponents: [InfoDialogComponent, ConfirmationDialogComponent, ExternalContentViewerComponent, OrganisationSelectorComponent],
  providers: [CookieService, {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: {hasBackdrop: true, autoFocus: true, disableClose: true}
  },
    {
      provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})

export class SharedModule {
}
